import {kebabCase} from 'lodash';
import classnames from 'classnames';
import styles from 'shared/registration/stylesheets/achievement-cards.module.scss';
import React from 'react';

interface AchievementCardProps {
  onClick: (name: string, isSelected: boolean) => void;
  isSelected: boolean;
  trackPrefix: string;
  data: {
    name: string;
    emoji: string;
    averageAwardAmount: number;
  };
}

export default function AchievementCard(props: AchievementCardProps): React.ReactElement {
  const {isSelected} = props;
  const {name, emoji, averageAwardAmount} = props.data;
  const nameKebab = kebabCase(name);
  const identifier = kebabCase(`${props.trackPrefix}-`) + nameKebab;
  const amountText = `$${averageAwardAmount}`;
  const label = props.isSelected ? `${amountText} Average Award Amount` : name;
  const onClick = (): void => props.onClick(name, !isSelected);

  return (
    <button
      key={name}
      className={classnames(styles.button, {[styles.selected]: isSelected})}
      type="button"
      aria-label={label}
      aria-live="assertive"
      onClick={onClick}
      data-segment-track="button"
      data-button-name={identifier}
      data-cy={`card.${nameKebab}`}
    >
      <div className="achievement-step-emoji" aria-hidden>
        {emoji}
      </div>
      <span className={classnames('achievement-step-text', {selected: isSelected})}>{name}</span>
      {averageAwardAmount && (
        <span className={classnames('achievement-step-award', {selected: isSelected})}>
          <p className="achievement-step-award-text">{amountText}</p>
        </span>
      )}
    </button>
  );
}
